import React, { useCallback } from 'react';

import { AlmeAppState } from "../AlmeApp/AlmeAppState";

import { IconButton } from '@material-ui/core';
import { FocusComponentProps } from '../../models/ComponentProps';
import { AlmeMinimizeConfig } from './AlmeMinimizeConfig';

import MinimizeIcon from '@material-ui/icons/Remove';
import { AlmeApiUtils } from '../../api/AlmeApiUtils';
import { AlmeIvaTypeProp } from '../../models/AlmeIvaTypeMapping';
import { useIntl } from 'react-intl';
import {useFocusStyles} from '../FocusVisibleStyle';

interface AlmeMinimizeProps {
    almeConfig: AlmeMinimizeConfig;
    onMinimizeClick: () => void;
    ivaType?: AlmeIvaTypeProp;
    focusProps?: FocusComponentProps;
}

const AlmeMinimize: React.FC<AlmeMinimizeProps> = (props: AlmeMinimizeProps) => {
    const classes = useFocusStyles();
    const intl = useIntl();
    if (!props.almeConfig.minimize.isMinimizeEnabled || props.ivaType === 'popup') {
        return null;
    }

    const onMinClick = () => {
        props.onMinimizeClick();
        const data = {
            message: {
                type: 'MinimizeIva',
            },
        };
        window.top?.postMessage(data, "*");
    };

    const defaultIcon = props.almeConfig.minimize.minimizeIcon || <MinimizeIcon />;
    const fontSize = props.almeConfig.minimize.styles.buttonSize || 'small';
    const minimizeIcon = React.cloneElement(defaultIcon, { fontSize });

    return (
        <IconButton
            className={classes.visibleFocus}
            title={intl.formatMessage({
                id: "minimize.minimizeTitle",
                defaultMessage: 'Default Minimize',
                description: 'Minimize icon tool tip',
            })}
            color='inherit'
            id='alme-minimize'
            aria-label={
                intl.formatMessage({
                    id: "minimize.minimizeAriaLabel",
                    defaultMessage: 'Default minimize aria label',
                    description: 'AlmeMinimize aria label',
                })}
            onClick={onMinClick}
            {...props.focusProps}
        >
            {minimizeIcon}
        </IconButton>
    );
};

export default AlmeMinimize;

export function OnMinimizeClick(almeState: AlmeAppState, setAlmeState: (state: AlmeAppState) => void, apiUtils: React.MutableRefObject<AlmeApiUtils>): () => void {
    return useCallback(() => {
        void apiUtils.current.submitReportingEvent('MinimizeClicked', 'true');
        setAlmeState({
            ...almeState,
            isOpen: false,
            isMinimized: true,
        });
    }, [almeState, setAlmeState, apiUtils]);
}
